import { Phone, MessageCircle, Clock, MapPin, Mail } from "lucide-react";
import { BRAND, BRANCHES, telLink, waLink } from "@/lib/brand";
import { TESTIDS } from "@/constants/testIds";
import RateEnquiry from "@/components/RateEnquiry";

export default function ContactPage() {
  return (
    <div>
      <section className="bg-[#2D181A] text-[#FFFDF8]">
        <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 py-20 md:py-28">
          <div className="text-[10px] uppercase tracking-[0.3em] text-[#D4AF37] font-bold">
            Contact · संपर्क
          </div>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight mt-4 leading-[1.02] max-w-4xl">
            Talk to us for{" "}
            <span className="italic text-[#D4AF37]">the best rate</span>.
          </h1>
          <p className="mt-6 text-base md:text-lg text-[#FFFDF8]/80 leading-relaxed max-w-3xl">
            Call or WhatsApp — we respond within minutes during business
            hours. For appointments outside Gurgaon (home visits) please give
            us prior notice.
          </p>
        </div>
      </section>

      <section
        data-testid={TESTIDS.contactSection}
        className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 py-16 md:py-24"
      >
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8">
          <a
            data-testid={TESTIDS.contactCallBtn}
            href={telLink}
            className="group bg-white border border-[#E5DCC5] p-10 md:p-12 shadow-sm hover:shadow-lg transition-all"
          >
            <div className="w-14 h-14 bg-[#641C24] text-[#FFFDF8] flex items-center justify-center">
              <Phone size={22} strokeWidth={1.8} />
            </div>
            <div className="text-[10px] uppercase tracking-[0.28em] text-[#641C24] mt-6 font-bold">
              Call Now · कॉल करें
            </div>
            <div className="font-display text-3xl md:text-4xl font-bold tracking-tight mt-3 text-[#2D181A] group-hover:text-[#641C24] transition-colors">
              {BRAND.phone}
            </div>
            <p className="text-sm text-[#4A3B3C] mt-4 leading-relaxed">
              Direct line to our branch. Ask for today's best rate — we quote
              on-call and lock it for you at branch.
            </p>
          </a>

          <a
            data-testid={TESTIDS.contactWhatsappBtn}
            href={waLink()}
            target="_blank"
            rel="noopener noreferrer"
            className="group bg-white border border-[#E5DCC5] p-10 md:p-12 shadow-sm hover:shadow-lg transition-all"
          >
            <div className="w-14 h-14 bg-[#25D366] text-white flex items-center justify-center">
              <MessageCircle size={22} strokeWidth={1.8} />
            </div>
            <div className="text-[10px] uppercase tracking-[0.28em] text-[#641C24] mt-6 font-bold">
              WhatsApp · व्हाट्सएप
            </div>
            <div className="font-display text-3xl md:text-4xl font-bold tracking-tight mt-3 text-[#2D181A] group-hover:text-[#641C24] transition-colors">
              Chat Now
            </div>
            <p className="text-sm text-[#4A3B3C] mt-4 leading-relaxed">
              Send photos of your ornaments, share weight — get a rate
              estimate before you leave home.
            </p>
          </a>
        </div>

        {/* Branch summary */}
        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {BRANCHES.map((b) => (
            <div
              key={b.id}
              className="bg-[#FAF6EC] border border-[#E5DCC5] p-8"
            >
              <h3 className="font-display text-2xl font-bold tracking-tight">
                {b.name}
              </h3>
              <div className="text-[10px] uppercase tracking-[0.22em] text-[#641C24] mt-1">
                {b.hindi}
              </div>
              <div className="mt-5 space-y-2.5 text-sm text-[#4A3B3C]">
                <div className="flex items-start gap-2">
                  <MapPin size={14} className="mt-0.5 text-[#D4AF37]" />
                  {b.address}
                </div>
                <div className="flex items-center gap-2">
                  <Clock size={14} className="text-[#D4AF37]" /> {b.hours}
                </div>
                <div className="flex items-center gap-2">
                  <Phone size={14} className="text-[#D4AF37]" /> {BRAND.phone}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-14 flex items-start gap-3 text-sm text-[#4A3B3C] max-w-3xl">
          <Mail size={16} className="mt-0.5 shrink-0 text-[#641C24]" />
          <p>
            Prefer email? Send a note with your name, city and weight (grams)
            of gold to any of our branch numbers via WhatsApp — we'll reply
            with an on-call estimate the same day.
          </p>
        </div>
      </section>

      <RateEnquiry />
    </div>
  );
}
